import "core-js/modules/es6.object.define-property.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { Configuration } from "../Shared/Configuration";
import { Ajax } from "./Ajax";
export var ProductsApiService = /*#__PURE__*/function () {
  function ProductsApiService() {
    _classCallCheck(this, ProductsApiService);

    var config = new Configuration();
    this._appRoot = config.GetAppRoot();
  }

  _createClass(ProductsApiService, [{
    key: "GetProduct",
    value: function GetProduct(id, eventId) {
      var eventParticipantId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var url = "".concat(this._appRoot, "/Api/ProductsApi/GetProduct/?id=").concat(id, "&eventId=").concat(eventId);

      if (eventParticipantId !== null) {
        url += "&eventParticipantId=".concat(eventParticipantId);
      }

      return Ajax.Get(url);
    }
  }, {
    key: "ValidPromoCode",
    value: function ValidPromoCode(productId, promoCode, needToValidate) {
      var url = "".concat(this._appRoot, "/Api/ProductsApi/ValidPromoCode/?id=").concat(productId, "&promoCode=").concat(promoCode, "&editExistingPromoCode=").concat(!needToValidate);
      return Ajax.Get(url);
    }
  }]);

  return ProductsApiService;
}();